<template>
  <CMS>
    <Loader v-if="!resource" />
    <Blocks v-if="resource" :resource="resource" />
  </CMS>
</template>

<script>
// import Blocks from '@/components/blocks'
import { BlocksComponent as Blocks } from '../defaults/blocks'
import CMS from '../components/cms'
import Loader from '../components/loader'
import pageMixin from '../mixins/page-mixin'

export default {
  components: {
    Blocks,
    CMS,
    Loader
  },
  mixins: [ pageMixin ]
}
</script>
